import config from "../../config/local-config";
import isMembershipSku from '@usap/widgets/src/helpers/isMembershipSku';
import { getPageDynamicData } from '@usap/carparts/src/shared/helpers'

export const isItemEligibleForReturn = (inputDate, returnUnavailableMessage = {}) => {
  const { returnWindow = 35 } = config || {};

  // If there's no tracking creation date (for recently placed orders)
  if (!inputDate)
    return {
      eligible: false,
      message: returnUnavailableMessage?.default,
    };

  const trackingCreationDate = new Date(inputDate);
  const currentDate = new Date();
  const differenceInDays =
    (currentDate - trackingCreationDate) / (1000 * 60 * 60 * 24);

  // If the tracking creation date is older than 35 days from current timestamp
  if (differenceInDays > returnWindow)
    return {
      eligible: false,
      message: returnUnavailableMessage?.returnWindowExpired,
    };

  // For eligible orders
  return {
    eligible: true,
    message: "",
  };
};

export const getMostRecentShippingDate = (shippingDates) => {
  if (!shippingDates) return null;

  
  if (Array.isArray(shippingDates) && shippingDates.length !== 0) {
    const dateObjects = shippingDates
      .filter(shippingObj => shippingObj?.date_created) // Check for valid date_created values
      .map(shippingObj => new Date(shippingObj.date_created));
  
    if (dateObjects.length === 0) return null;
    if (dateObjects.length === 1) return dateObjects[0]; // Return the first date if only 1 date is valid
  
    dateObjects.sort((a, b) => b - a); // Sort in descending order
    return dateObjects[0]; // Return the most recent date
  }
   else if (typeof shippingDates === "object") {
    return shippingDates?.date_created ? new Date(shippingDates?.date_created) : null;
  }
  return null;
};

export const checkReturnEligibility = (itemInfo) => {
  let mostRecentShippingDate;
  const parentSku = itemInfo?.parentSku;
  const shippingInfo = itemInfo?.shipping;

  // For Set/Kit items
  if (parentSku) {
    const mostRecentDate = getMostRecentShippingDate(parentSku?.shipping);
    mostRecentShippingDate = mostRecentDate
      ? mostRecentDate.toISOString().replace("T", " ").slice(0, 19)
      : "";
  } else mostRecentShippingDate = shippingInfo?.date_created; // For normal items
  
  const {return_unavailable_message: returnUnavailableMessage = {}} = getPageDynamicData({
    widgetName: "RMA"
  });

  if(isMembershipSku(itemInfo.sku)) {
    return {
      eligible: false,
      message: returnUnavailableMessage?.membership,
    };
  }
  
  return isItemEligibleForReturn(mostRecentShippingDate, returnUnavailableMessage);
};

export default {isItemEligibleForReturn, getMostRecentShippingDate, checkReturnEligibility};
